export default __webpack_public_path__ + "static/kindergarten-readiness5-f35730c36c6313867ee58d7ed82a89c6.jpg";